<template>
  <div>
    <h6 class="pb-4 text-2xl text-default-600">
      Foram encontrados {{ searchResults.meta.total }} resultados para a busca <span class="font-bold">"{{search}}"</span>
    </h6>
    <div class="bg-white">
      <ul class="divide-y divide-default-500">
        <card-search-component v-for="(result, item) in searchResults.data" :key="item" :record="result"/>
      </ul>
      <paginate
        v-if="searchResults.data"
        :meta="searchResults.meta"
        :links="searchResults.links"
        event="paginatesearchResults"
        @paginatesearchResults="paginate"
        class="my-1 pb-1"
      />
    </div>
  </div>
</template>

<script>
import Search from "../api/models/Search";
import CardSearchComponent from "./CardSearchComponent";
import Paginate from "./global/Paginate.vue";

export default {
  name: "SearchPageComponent",
  components: { CardSearchComponent, Paginate },

  props: ["search"],
  data() {
    return {
      searchResults: {
        data: {},
        links: {},
        meta: {},
      },
      pagNumbers: {},
    };
  },
  created: function () {
    Search.all(this.search).then((response) => {
      this.searchResults = response;
      this.pagNumbers = this.calc(response.meta);
    });
  },
  methods: {
    paginate(url) {
      if (url !== null) {
        Search.get(url).then((response) => {
          this.searchResults = response;
          this.pagNumbers = this.calc(response.meta);
        });
      }
    },
  },
};
</script>

<style scoped>
</style>
